
import C42JWT from '@c42/jwt';

const c42Jwt = new C42JWT();

export default c42Jwt;
